import { createApp } from 'vue'
import { createWebHashHistory, createRouter } from 'vue-router'
import App from './App'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@fortawesome/fontawesome-free/css/v4-shims.min.css'
import PaginaInicial from './components/paginainicial/PaginaInicial'
import Noticia from './components/paginainicial/Noticia'
import NuvemCallback from './components/paginainicial/NuvemCallback'
import LoginUnicoCallback from './components/paginainicial/LoginUnicoCallback'
import TrocarSenha from './components/paginainicial/TrocarSenha'
import AutenticacaoSIOP from './components/paginainicial/AutenticacaoSIOP'
import Cadastradores from './components/Cadastradores.vue'
import CadastradoresSof from './components/CadastradoresSof.vue'
import webchat from '../public/static/js/webchat-v0.9.0.js'
import { apolloProvider } from './apollo.js'
import { jwtDecode } from 'jwt-decode'
import './css/govbr.css'
import './css/reset.css'
import './css/style.css'

// Funções auxiliares
const isValidToken = (token) => {
  return token != null && token !== '' && token !== 'null'
}

const isTokenExpired = (decodedToken) => {
  return !decodedToken || decodedToken.exp <= new Date().getTime() / 1000
}

const clearAuthData = () => {
  window.localStorage.removeItem('token')
  window.localStorage.removeItem('refreshToken')
  window.localStorage.removeItem('usuario')
}

const clearTokenData = () => {
  window.localStorage.removeItem('token')
  window.localStorage.removeItem('usuario')
}

const refreshAuthToken = async (refreshToken) => {
  try {
    const response = await fetch('/modulo/login/api', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ query: `query token { token(refreshToken: "${refreshToken}")}` })
    })
    if (response.ok) {
      const data = await response.json()
      if (data?.data?.token) {
        window.localStorage.setItem('token', data.data.token)
        return true
      }
    }
    clearAuthData()
    return false
  } catch {
    clearAuthData()
    return false
  }
}

const validateAndRefreshToken = async (token, refreshToken) => {
  try {
    if (!isValidToken(token)) {
      clearTokenData()
    } else {
      const usuario = jwtDecode(token)

      // Se precisa trocar senha retornar
      if (usuario.trocarSenha) {
        return false
      }

      // Token válido e não expirado
      if (!isTokenExpired(usuario)) {
        return true
      }
    }

    // Token expirado, refresh Token inválido retornar falso
    if (!isValidToken(refreshToken)) {
      clearAuthData()
      return false
    }

    // Verificar se o refresh token expirou
    const refreshUsuario = jwtDecode(refreshToken)
    if (isTokenExpired(refreshUsuario)) {
      clearAuthData()
      return false
    }

    return await refreshAuthToken(refreshToken)
  } catch (error) {
    if (error.name === 'InvalidTokenError') {
      clearTokenData()
    }
    return false
  }
}
console.log('Iniciando aplicação...')
// Inicialização de autenticação
const token = window.localStorage.getItem('token')
const refreshToken = window.localStorage.getItem('refreshToken')
const autenticado = await validateAndRefreshToken(token, refreshToken)

const app = createApp(App)
app.use(apolloProvider)
app.config.compilerOptions.whitespace = 'preserve'
app.config.globalProperties.$webchat = webchat

const routes = [
  { path: '/noticia', component: Noticia },
  { path: '/nuvemcallback', component: NuvemCallback },
  { path: '/loginunicocallback', component: LoginUnicoCallback },
  { path: '/trocarsenha', component: TrocarSenha },
  { path: '/definir-nova-senha', component: TrocarSenha },
  { path: '/autenticacaosiop', component: AutenticacaoSIOP },
  { path: '/cadastradores', component: Cadastradores },
  { path: '/cadastradoresSof', component: CadastradoresSof },
  { path: '/:pathMatch(.*)*', component: PaginaInicial }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

app.use(router)

router.beforeEach((to, from, next) => {
  if (to.path !== '/cadastradores' && to.path !== '/cadastradoresSof' && to.path !== '/definir-nova-senha' && autenticado) {
    window.location.href = '/modulo/main/index.html'
  } else {
    next()
  }
})

app.mount('#app')
